const CurrencyFormatter = ({ value, lang = 'en' } = {}) => {
  const number = Math.floor(value).toLocaleString(lang);
  return lang === 'fr' ? `${number} $` : `$${number}`;
};

export const FormatCurrency = (value, lang) => {
  const number = Math.floor(value).toLocaleString(lang);
  return lang === 'fr' ? `${number} $` : `$${number}`;
};

export const FormatPercentage = (value, lang, toDecimal) => {
  const percentage = Number(value).toFixed(toDecimal).toLocaleString(lang);
  return lang === 'fr' ? `${percentage} %` : `${percentage}%`;
};

export const FormatInterest = (value, lang) => {
  const percentage = Intl.NumberFormat(lang, {
    styled: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    roundingMode: 'floor',
  }).format(value);
  return lang === 'fr' ? `${percentage} %` : `${percentage}%`;
};

export default CurrencyFormatter;
